export default __webpack_public_path__ + "static/media/belicoso.989c2142.png";